module.exports = __webpack_public_path__ + "img/zhuan3.022c5e74.png";